import { Box, Container, Drawer, IconButton, Stack, useTheme } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Item } from "./item";
import { LogoImage } from "./logo";
import React from "react";
export const Menu = ({ isOpen, items = [], logo, toggle }) => {
    const theme = useTheme();
    return (React.createElement(Drawer, { anchor: "right", open: isOpen, onClose: toggle, ModalProps: { keepMounted: true }, sx: {
            "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                background: theme.palette.primary.main,
                width: "100%",
            },
        } },
        React.createElement(Container, { sx: { pt: 2, pb: 3 } },
            React.createElement(Stack, { direction: "row", justifyContent: "flex-end" },
                React.createElement(IconButton, { "aria-label": "Hauptmen\u00FC schlie\u00DFen", color: "secondary", size: "small", onClick: toggle },
                    React.createElement(Close, { fontSize: "small" }))),
            React.createElement(Box, { sx: { display: "flex", justifyContent: "center", pt: 0, width: "100%" } },
                React.createElement(LogoImage, { isSticky: false, logo: logo })),
            React.createElement(Stack, { component: "ul", role: "navigation", sx: { alignItems: "center", pt: 8, pl: 0, pr: 0, listStyleType: "none" }, spacing: 3 }, items.map(({ label, route }) => (React.createElement(Box, { component: "li", key: `mobile-nav-item-${label}-${route}` },
                React.createElement(Item, { label: label, route: route }))))))));
};
//# sourceMappingURL=menu.js.map